<template>
  <v-container class="form-container mt-1 white elevation-2">
    <v-row no-gutters align="center">
      <v-btn icon depressed color="primary" @click="$router.back()">
        <v-icon> mdi-undo </v-icon>
      </v-btn>
      <span class="title">{{ module.name }} Steps</span>
      <v-spacer></v-spacer>
    </v-row>

    <v-divider></v-divider>

    <step :module="module" ctrl="workflow" :steps="ctrl.steps" />

    <confirmation-dialog ref="confirmationDialog" />
  </v-container>
</template>

<script>
import step from "./step";

export default {
  components: {
    step,
  },
  data() {
    return {
      ctrl: this.get_controller("workflow").sections.workflow_step,
      workflow_ctrl: this.get_controller("workflow"),
      module: null,
      workflow: {},
      moduleRefId: 0,
    };
  },
  created() {
    this.module = this.systemModules[this.$route.params.systemCode];
    this.allowedModules = this.module.getAllowedModules();
    if (this.ctrl.steps.length == 0) {
      this.workflow_ctrl.getWorkflowSteps(this.$route.params.id);
    }
  },
};
</script>